/* eslint-disable react/prop-types */

import moment from 'moment';
import React, { useContext } from 'react';
import { getPrice } from '../../../../common/routines/utils';
import JournalReportHOC, { TableDataContext } from '../../hoc/journalReportHoc';
import GenerateNarration from '../narrations';

const SalesJournals = () => {
  const journalTableData = useContext(TableDataContext);

  return (
    <>
      {journalTableData?.map((val, index) => {
        return (
          <React.Fragment key={index}>
            {val?.unitDetails?.map((unitDetail, columnIndex) => {
              return (
                <tr
                  id={columnIndex}
                  key={columnIndex}
                  className={
                    unitDetail?.transactionType === 'Dr'
                      ? 'text-dr journal-next'
                      : 'text-cr journal-next'
                  }
                >
                  <td>
                    {val.submissionDate && moment(val.submissionDate).isValid()
                      ? moment(val.submissionDate).format('MM/DD/YYYY')
                      : '-'}
                  </td>
                  <td className="journal-td-ex">
                    <div>{unitDetail?.details}</div>
                    <div>{unitDetail?.accountNumber}</div>
                  </td>
                  <td>{unitDetail?.transactionType}</td>
                  <td>{unitDetail?.contractNumber} </td>
                  <td className="dr-clr">
                    {unitDetail?.transactionType === 'Dr' ? getPrice(unitDetail?.amount) : ''}
                  </td>
                  <td className="cr-clr">
                    {unitDetail?.transactionType === 'Cr' ? getPrice(unitDetail?.amount) : ''}
                  </td>
                  <td
                    className={`${
                      unitDetail?.accountingStatus === 'Pending' ? 'j-due-td' : 'j-due-td-1'
                    }`}
                  >
                    {unitDetail?.accountingStatus.toUpperCase()}
                  </td>
                  <td>{unitDetail?.businessUnit}</td>
                  <td>{unitDetail?.entity}</td>
                </tr>
              );
            })}
            <tr id={index} className="journal-next">
              <td colSpan="9" className="journal-next-ex">
                <GenerateNarration data={val.narration} />
              </td>
            </tr>
            <br />
          </React.Fragment>
        );
      })}
    </>
  );
};

export default JournalReportHOC(SalesJournals);
